export const api = process.env.VUE_APP_API
export const api_main = process.env.VUE_APP_API_MAIN
export const api_lp = process.env.VUE_APP_API_LP
